<template lang="pug">
.header
  img.logo(
    :src="require('../assets/logo.png')",
    @click="toIndex")
  img.menu(
    @click="show",
    :src="require('../assets/menu.png')")
  slot
  transition(name="right-slide")
    rightbar(
      @close="close",
      v-if="showRight")
</template>

<script>
import rightbar from './rightbar'
const Header = {
  props: [],
  data () {
    return {
      showRight: false
    }
  },
  components: {
    rightbar
  },
  computed: {

  },
  methods: {
    toIndex () {
      this.$router.push('/')
    },
    show () {
      this.showRight = true
    },
    close () {
      this.showRight = false
    }
  }
}
export default Header
</script>

<style scoped lang="stylus">
@media (max-width: 720px) {
  .header{
    position: fixed;
    height: 300px;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    .logo{
      float: left;
      height: 120px;
      margin-top: 121px;
      margin-left: 120px;
      cursor: pointer;
    }

    .menu{
      float: right;
      height: 120px;
      margin-top: 121px;
      margin-right: 120px;
      cursor: pointer;
    }
  }
}
@media (min-width: 720px) {
  .header{
    position: absolute;
    height: 150px;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    .logo{
      float: left;
      height: 50px;
      margin-top: 61px;
      margin-left: 78px;
      cursor: pointer;
    }
    .menu{
      float: right;
      height: 50px;
      margin-top: 61px;
      margin-right: 93px;
      cursor: pointer;
    }
  }
}
.right-slide-enter-active {
  transition: all .3s ease-out
}
.right-slide-leave-active {
  transition: all .3s ease-out
}
.right-slide-enter, .right-slide-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(500px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// header.vue?3264b4e0